export const API_ROUTE_TRANSLATIONS = 'translations/app'
export const API_ROUTE_TRANSLATION = 'app/translation'

export const API_PATH_AUTHENTICATE = 'app/authenticate'

export const API_PATH_STATUS = 'app/status'
export const API_PATH_EMPLOYEE_CONSENT = 'app/consent/:consentId'
export const API_PATH_SUB_SERVICES = 'app/subscription-services'
export const API_PATH_SUB_SERVICES_ADD_SERVICE = `${API_PATH_SUB_SERVICES}/:serviceId/add`
export const API_PATH_SUB_SERVICES_CANCEL_ORDER = `${API_PATH_SUB_SERVICES}/order/:orderId/cancel`

export const API_PATH_SUB_PC = 'app/pc'
export const API_PATH_SUB_PC_PRODUCTS = `${API_PATH_SUB_PC}/products`
export const API_PATH_SUB_PC_ORDER = `${API_PATH_SUB_PC}/order`
export const API_PATH_SUB_PC_ADDRESSES = `${API_PATH_SUB_PC}/addresses`

export const API_PATH_ECOM = 'app/ecom'
export const API_PATH_ECOM_INVENTORY = `${API_PATH_ECOM}/inventory`
export const API_PATH_ECOM_ORDER = `${API_PATH_ECOM}/order`
export const API_PATH_ECOM_ORDER_INFO = `${API_PATH_ECOM}/order-info`

export const API_PATH_RESALE = 'app/resale'
export const API_PATH_RESALE_ORDER = `${API_PATH_RESALE}/order`

export const API_PATH_ECOM_PRODUCT_PRICE_VALIDATION = 'app/ecom-products/validate'

export const API_PATH_ECOM_POLICY_LIST = 'app/ecom/policies'
export const API_PATH_ECOM_POLICY = `${API_PATH_ECOM_POLICY_LIST}/:policyId`
export const API_PATH_ECOM_POLICY_ORDER = `${API_PATH_ECOM_POLICY}/order`
export const API_PATH_ECOM_POLICY_ORDER_DETAILS = `${API_PATH_ECOM_POLICY_LIST}/orders/:orderId`
export const API_PATH_ECOM_POLICY_GREENPOOL_ORDER_DETAILS = `${API_PATH_ECOM_POLICY_LIST}/greenpool-orders/:orderId`
export const API_PATH_ECOM_POLICY_GREENPOOL_ORDER = `${API_PATH_ECOM_POLICY}/greenpool-order`
export const API_PATH_ECOM_POLICY_MANDATORY_PRODUCTS = `${API_PATH_ECOM_POLICY}/mandatory-products`

export const MANAGER_API_ACTIVE_EMPLOYEE_CONSENT = 'employee-consent/active'
export const MANAGER_API_ACCEPT_EMPLOYEE_CONSENT = 'employee-consent/:consentId/accept'
export const MANAGER_API_REVOKE_EMPLOYEE_CONSENT = 'employee-consent/:consentId/revoke'

export const API_PATH_MASTER_ORDERS = 'app/master-orders'

// new Backend

export const API_PATH_CARRIER = 'carrier'
export const API_PATH_CARRIER_BYID = `${API_PATH_CARRIER}/byid`
